import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [
  // View Menu
  nativeCommsMessageTypes.REDO
];
